import { AirflowTaskType } from "types/airflow";
import { DatasetIdentifierStr } from "../dataset/DatasetIdentifierStr";
import { AirflowWorkerQueue, ChronoUnitStr } from "../enums";
import { ProductTemplateTaskSelectionOptions } from "../product-template/ProductTemplateTaskSelectionOptions";
import { TaskTemplateInfo } from "./task-template/TaskTemplateInfo";
import { TaskInputGroup } from "./TaskInputGroup";

// eslint-disable-next-line import/prefer-default-export
export class ScheduledTaskDTO {
  id?: string;

  parentId?: string;

  companyId?: number;

  companyRef?: string;

  title: string = "";

  description: string | null = "";

  useCategories: boolean = false;

  environmentId: string = "eapy_20250719";

  type: AirflowTaskType = "STANDARD";

  executorQueue: AirflowWorkerQueue = "DEFAULT";

  queueSlots: number = 1;

  timeout: number = 300;

  isSkipped: boolean = false;

  allowEditLocked: boolean = false;

  strictDataMode: boolean = true;

  downstreamTasks: string[] = [];

  upstreamTasks: string[] = [];

  constants: Record<string, string> = {};

  productTemplates: Record<number, ProductTemplateTaskSelectionOptions> = {};

  freestyleJson: string = "{\n\t\n}";

  indexedInputDatasets: DatasetIdentifierStr[] = [];

  indexedOutputDatasets: DatasetIdentifierStr[] = [];

  namedInputDatasets: Record<string, DatasetIdentifierStr> = {};

  namedOutputDatasets: Record<string, DatasetIdentifierStr> = {};

  inputCategories: Record<string, number> = {};

  outputCategories: Record<string, number> = {};

  categoryDataLag: number = 0;

  categoryDataLagUnit: ChronoUnitStr = "HOURS";

  categoryDataLead: number = 0;

  categoryDataLeadUnit: ChronoUnitStr = "HOURS";

  dataLag: number = 65;

  dataLagUnit: ChronoUnitStr = "MINUTES";

  dataLead: number = 0;

  dataLeadUnit: ChronoUnitStr = "MINUTES";

  calculationTimeOffset: number = 0;

  calculationTimeOffsetUnit: ChronoUnitStr = "MINUTES";

  calculationPeriod: number = 1;

  calculationPeriodUnit: ChronoUnitStr = "MINUTES";

  calculationSteps: number = 1;

  extraExecutionRecipients: string[] = [];

  overrideRecipients: boolean = false;

  codeFileName: string | null = null;

  codeFileId: number | null = null;

  code?: string | null = null;

  codeB64?: string | null = null;

  templateInfo: TaskTemplateInfo = {};

  inputGroups: Record<string, TaskInputGroup[]> = {};

  includeTokens: boolean = false;

  lastUpdated?: string;

  lastUpdatedBy?: string;

  sendsAlerts?: boolean;

  constructor(data?: Partial<ScheduledTaskDTO>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
